import {Errors} from '../errors';
import {Message, ToType} from '../message';
import {BaseCommandMessage, BaseResponseMessage, ErrorResponseMessage} from "./base";

export const COMMAND_SEND_TO = 'send_to';
export const COMMAND_SEND_TO_IGNORE = 'send_to_ignore';

export namespace SendToCommandNamespace {

    export class CommandMessage extends BaseCommandMessage {
        public fileName: string;

        constructor(readonly to: string, readonly toType: ToType, readonly message: Message) {
            super(COMMAND_SEND_TO);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly from: string, readonly to: string, readonly toType: ToType, readonly message: Message) {
            super(COMMAND_SEND_TO, id, true);
        }
    }

    export class ErrorResponse extends ErrorResponseMessage {
        constructor(override readonly id: number, error: number, readonly to: string, readonly toType: ToType, readonly message: Message) {
            super(COMMAND_SEND_TO, id, error);
        }
    }

    export class NotEnoughTimeAfterLogin extends ErrorResponse {
        constructor(override readonly id: number, override readonly to: string, override readonly toType: ToType, override readonly message: Message, readonly leftToAvailabilitySendMessage: number) {
            super(id, Errors.NOT_ENOUGH_TIME_AFTER_LOGIN, to, toType, message);
        }
    }

    export class ToManyImagesInMainChatResponse extends ErrorResponse {
        constructor(override readonly id: number, override readonly to: string, override readonly toType: ToType, override readonly message: Message, readonly imagePerPeriod: number,) {
            super(id, Errors.TO_MANY_IMAGES_IN_MAIN_CHAT, to, toType, message);
        }
    }
}

export namespace SendToIgnoreNamespace {
    export class CommandMessage extends BaseCommandMessage {
        constructor(readonly login: string, readonly isPrivate: boolean) {
            super(COMMAND_SEND_TO_IGNORE);
        }
    }
}
